// extracted by mini-css-extract-plugin
module.exports = {"brand":"Page_brand__J4K2j","page-branding":"Page_page-branding__iKlze","page-footer":"Page_page-footer__vzYp4","page-view":"Page_page-view___ZS1w"};